import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormColorStatusDirective } from './../../directives/color-status.directive';
import { InternalStatusMessage } from './../../models';

@Component({
	selector: 'app-validation-input-message',
	template: `
		@if (statusMessage) {
			<small
				role="alert"
				aria-label="Errore di validazione"
				[appColorStatus]="statusMessage.status"
				class="ps-1"
				><strong
					[translate]="statusMessage.text"
					[translateParams]="statusMessage.params"
				></strong
			></small>
		}
	`,
	standalone: true,
	imports: [FormColorStatusDirective, TranslateModule]
})
export class ValidationInputMessagesComponent {
	@Input() statusMessage: InternalStatusMessage;
}
